export default class CalculatePersonalizedValues
{
    constructor(submittedAnswers, personalizationSettings, defaultPersonalizedValues)
    {
        this.submittedAnswers = submittedAnswers;
        this.personalizationSettings = personalizationSettings;
        this.defaultPersonalizedValues = defaultPersonalizedValues;
    }

    execute()
    {
        let personalizedConfig = this.defaultPersonalizedValues;

        // Loop through all personalized settings and check for matches
        this.personalizationSettings.forEach((setting, index) => {
            // Skip this question if it has not been answered
            if (!(setting.question_id in this.submittedAnswers)) {
                return;
            }

            // Answered, check if personalized config matches the chosen option. Skip if doesn't match.
            if (this.submittedAnswers[setting.question_id] !== setting.quiz_question_option_id) {
                return;
            }

            // Passed all checks, update config
            personalizedConfig = setting;
        });

        return personalizedConfig;
    }

}
